import { makeRequest } from "../utils/api";
import { toast } from "react-toastify";
import router from "../router/Router";

export const login =
  (setError) =>
  ({ identifier, password }) => {
    return makeRequest(
      `/auth/login`,
      "POST",
      { identifier, password },
      false,
      setError
    );
  };

export const register =
  (setError) =>
  ({ identifier, repeat_identifier, password, role }) => {
    return makeRequest(
        `/auth/register`,
        "POST",
        { identifier, repeat_identifier, password, role },
        false,
        setError
      );
  };

export const verification =
  (setError) =>
  ({ code }) => {
    return makeRequest(
        `/auth/verification`,
        "POST",
        { code },
        false,
        setError
      );
  };

export const resetPassword =
  (setError) =>
  ({ identifier }) => {
    return new Promise(async (resolve, reject) => {
      const response = await makeRequest(
        `/auth/reset-password`,
        "POST",
        { identifier },
        false,
        setError
      );
      toast.success(response.detail);
      router.navigate("/reset-password/confirm");
      resolve(response);
    });
  };

export const resetPasswordConfirm =
  (setError) =>
  ({ code, password1, password2 }) => {
    return makeRequest(
        `/auth/reset-password/confirm`,
        "POST",
        { code, password1, password2 },
        false,
        setError
      );
  };

export const logOut = () => {
  localStorage.removeItem("availabilityTracker");
  router.navigate("/login");
};
